import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OpportunitySecurityChecklistService from '../../../Services/opportunitySecurityChecklistService';
import OpportunitySecurityChecklistItem from '../../../Domain/OpportunitySecurityChecklistItem';
import EditOpportunitySecurityChecklistWindowDescription from './EditOpportunitySecurityChecklistWindowDescription';

// Step 2 of Copy Checklist from Another Opportunity: the ORDINARY checklist edit wizard, pre-filled with the
// source's values and opened as a create - the same hand-off "Copy Service From" makes to EditServiceDescription.
// So the copied values can be adjusted before saving, and a field added to the edit wizard is copied for free.
// Deliberately NO side-by-side compare step: the two sides would show the same values. Added here: the mandatory
// acknowledgement page and the audit save.
export default class CopyChecklistWindowDescription extends EditOpportunitySecurityChecklistWindowDescription {
  static titleForCreate = 'Copy Security Checklist from Another Opportunity';
  static titleForEdit = 'Copy Security Checklist from Another Opportunity';
  static finishButtonLabel = 'Copy checklist';

  // Restated though inherited: GeneralEditWizzardPageFigma SPREADS the description into its state, and a spread
  // copies own properties only.
  static itemType = OpportunitySecurityChecklistItem;
  static messageOnSuccess = 'The Security Checklist has been copied to this Opportunity.';

  // The regular save, flagged as a copy: that only adds the audit comment naming the source Opportunity, which a
  // plain save does not write. The source rides on the item as SourceOpportunityId / SourceOpportunityName.
  static serviceFunction = (edited) => OpportunitySecurityChecklistService.UpsertChecklist(edited, false, true);

  // The mandatory acknowledgement, naming the source row the picker returned.
  static acknowledgementText(editedItem) {
    const name = editedItem?.SourceOpportunityName ? editedItem.SourceOpportunityName : '(no name)';
    const client = editedItem?.SourceClientName ? ` (${editedItem.SourceClientName})` : '';

    return (
      `You are about to copy the Security Checklist from Opportunity ${name} (${editedItem?.SourceOpportunityId})` +
      `${client}. By confirming, you accept personal responsibility that this information is current, accurate, ` +
      'and applicable to this opportunity. This action will be permanently logged with your name, ID, and timestamp.'
    );
  }

  static pagesInGeneralEditWizzard = [
    ...EditOpportunitySecurityChecklistWindowDescription.pagesInGeneralEditWizzard,
    {
      label: 'Acknowledgement',
      // A function, so the source Opportunity and its client are named in the text itself.
      description: CopyChecklistWindowDescription.acknowledgementText,
      fields: [
        {
          fieldName: 'CopyConfirmed',
          label: 'I confirm the copied data is correct and applicable to this opportunity',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          // The wizard validates every page once on the last one, so Finish stays disabled until this is on.
          validityChecker: (value) =>
            value === true ? '' : 'You must confirm the copied data is correct and applicable before saving.',
        },
      ],
    },
  ];
}
